// extracted by mini-css-extract-plugin
module.exports = {"dropdownButton":"LocaleSelection_dropdownButton__D3Pf4","dropdownAnchor":"LocaleSelection_dropdownAnchor__2pHo9","spinning":"LocaleSelection_spinning__n0iaZ"};